import {
  Maybe,
  Movie,
  Person,
  PersonActivity,
  Position,
  Series
} from 'types/graphql-api.generated';

type PartialMovie = Pick<Movie, '__typename'> & {
  credits?: Maybe<{
    edges?: Maybe<
      Array<
        Maybe<{
          node?: Maybe<{
            person?: Maybe<Pick<Person, 'firstName' | 'lastName'>>;
            position?: Maybe<Pick<Position, 'name'>>;
          }>;
        }>
      >
    >;
  }>;
};
type PartialSeries = Pick<Series, '__typename'> & {
  credits?: Maybe<{
    edges?: Maybe<
      Array<
        Maybe<{
          node?: Maybe<{
            person?: Maybe<Pick<Person, 'firstName' | 'lastName'>>;
            position?: Maybe<Pick<Position, 'name'>>;
          }>;
        }>
      >
    >;
  }>;
};

export const isPartialMovie = (candidate: any): candidate is PartialMovie =>
  candidate.__typename === 'Movie';
export const isPartialSeries = (candidate: any): candidate is PartialSeries =>
  candidate.__typename === 'Series';

export const getEntityDirectors = (
  entity?: Maybe<PartialMovie | PartialSeries>,
  bypass = false
) =>
  Array.isArray(entity?.credits?.edges)
    ? entity?.credits.edges?.reduce<string[]>((acc, credit) => {
        if (
          bypass ||
          credit?.node?.position?.name === PersonActivity.Director
        ) {
          const firstName = credit?.node?.person?.firstName ?? '';
          const lastName = credit?.node?.person?.lastName ?? '';
          if (firstName.length || lastName.length) {
            acc.push(`${firstName} ${lastName}`);
          }
        }
        return acc;
      }, [])
    : [];
